import { Injectable } from '@angular/core';
import { RestService } from '@app/core/rest.service';
import { Observable } from 'rxjs/Observable';
import { Kyc } from '@app/core/models/kyc';
import { AgentInfo } from './models/agent';
import { Subject } from 'rxjs';
import { timeout, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

import { setDataFinancial, setDataProfile } from '@app/core/selectors';

import * as _ from 'lodash';
import * as moment from 'moment';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { LoadingService } from '@app/core/loading.service';
import { environment } from 'environments/environment';
import { CustomerProfile } from '@app/core/models/singpass.model';

@Injectable()
export class KycService extends RestService {
  private _relativeUrl = 'api/kyc/GetUserKYCWellnex?userCode=';
  private _relativeCampaignUrl = 'api/kyc/GetCampaignKYCWellnex?userCode=';
  private _relativeUrlValidEmailClient = 'api/KYC/ValidEmailClient?email=';
  private _relativeUrlGetApiKey = 'api/Tenant/ApiKey?name=';
  private _relativeUrlNationalityList = 'api/Nationality/NationalityList';
  private _relativeInfoUrl = 'api/KYC/FastKycInfo';
  private _relativeQuickInfoUrl = 'api/KYC/quick-info';
  kyc: Kyc = new Kyc();
  agentInfoObservable: Subject<AgentInfo> = new Subject();
  logoImageObservable: Subject<string> = new Subject();
  browserRefresh = false;
  kycInfo: any = {};
  apikey: any = {};
  agentInfo: AgentInfo;
  isQuickKyc = environment.isQuickKyc;
  isWhatsAppRegister = false;
  /** Populated after a successful Singpass MyInfo callback */
  customerProfile: CustomerProfile = null;

  constructor(http: Http, private _router: Router, loadingService: LoadingService) {
    super(http, loadingService);
  }

  getAgentInfo() {
    return this.agentInfoObservable.asObservable();
  }

  getLogoImage() {
    return this.logoImageObservable.asObservable();
  }

  getSaveKycEndpoint() {
    if (this.isWhatsAppRegister) return 'quick-whatsapp'
    else if (this.isQuickKyc) return 'quick'
    else return 'SaveKycMyPlanner';
  }

  getKycInfoEndpoint() {
    if (this.isWhatsAppRegister) return this._relativeQuickInfoUrl + '?isWhatsApp=true'
    else if (this.isQuickKyc) return this._relativeQuickInfoUrl
    else return this._relativeInfoUrl;
  }

  saveKyc(payload): Observable<any> {
    const apiPayload = {
      agentId: this.agentInfo.id,
      customerIdReferral: this.agentInfo.customerId,
      kycType: this.agentInfo.kycType,
      campaignId: this.agentInfo.campaignId,
      tenantId: this.kycInfo.TenantId,
      profile: null,
      KYCFinancial: null,
      KYCCoverages: null,
      KYCNeedAssessments: null,
      KYCRiskProfiles: null,
      KYCDependants: null,
      NumberOfRooms: null
    };
    const { questionCoverages, questionRiskProfiles } = payload.coverage;
    const { financial } = payload.financial;
    const { lifestyle } = payload.lifestyle;
    const { profile } = payload;
    const { questionNeedAssessments } = payload.needs;
    const { save } = payload.save;
    if (!questionCoverages) {
      throw new Error('coverage has not been created');
    }
    if (!questionNeedAssessments) {
      throw new Error('needs has not been created');
    }
    if (!save) {
      throw new Error('save has not been created');
    }
    apiPayload.KYCCoverages = questionCoverages;
    apiPayload.KYCRiskProfiles = questionRiskProfiles;
    apiPayload.KYCNeedAssessments = questionNeedAssessments;
    apiPayload.KYCFinancial = { ...setDataFinancial(financial, lifestyle) };
    _.forEach(save, saveItem => {
      if (saveItem.key === 'NumberOfRooms') {
        apiPayload.NumberOfRooms = saveItem.value;
      } else if (saveItem.key === 'Nationality') {
        _.forEach(this.kyc.save.NATIONALITIES, nationalitiesItem => {
          if (nationalitiesItem.Name === saveItem.value) {
            saveItem.value = nationalitiesItem.Name;
          }
        });
      }
    });

    apiPayload.profile = setDataProfile(save, profile);

    const lastName = save.find(item => item.key === 'LastName').value;
    apiPayload.KYCDependants = [];
    if (Number(payload.profile.userProfile.marital) === 0) {
      apiPayload.KYCDependants.push({
        FirstName: 'Spouse',
        LastName: lastName,
        Gender: Number(payload.profile.userProfile.gender) === 1 ? 0 : 1,
        RelationshipRole: 'Spouse',
        Nationality: apiPayload.profile['Nationality']
      });
    }
    const quantityBoys = payload.profile.quantityBoys;
    const quantityGirls = payload.profile.quantityGirls;
    for (let i = 0; i < quantityBoys; i++) {
      apiPayload.KYCDependants.push({
        FirstName: 'Kid',
        LastName: lastName,
        RelationshipRole: 'Kids',
        Gender: 1,
        Nationality: apiPayload.profile['Nationality']
      });
    }
    for (let i = 0; i < quantityGirls; i++) {
      apiPayload.KYCDependants.push({
        FirstName: 'Kid',
        LastName: lastName,
        RelationshipRole: 'Kids',
        Gender: 0,
        Nationality: apiPayload.profile['Nationality']
      });
    }

    const url = `/api/hub`;
    return this.post(
      url,
      {
        payload: JSON.stringify(apiPayload),
        apiUrl: 'api/kyc/' + this.getSaveKycEndpoint()
      },
      true
    ).pipe(
      catchError(err => {
        throw err;
      })
    );
  }

  sendEmailDowloadReportPDF(data): Promise<any> {
    const url = `/api/hub`;
    return new Promise((resolve, reject) => {
      this.post(
        url,
        {
          payload: JSON.stringify(data),
          apiUrl: 'api/kyc/SendEmailDowloadReportPDF'
        },
        true
      ).subscribe(value => {
        if (value.data.Info.Result === 'ERROR') {
          return reject(value.data.Info.Message);
        }

        return resolve(value);
      });
    });
  }

  validEmailClient(email): Observable<any> {
    const encodedUri = encodeURI(
      `${this._relativeUrlValidEmailClient}${email}`
    );

    return this.get(`/api/hub?path=${encodedUri}`, true);
  }

  getNationalityList(): Observable<any> {
    const encodedUri = encodeURI(`${this._relativeUrlNationalityList}`);
    return this.get(`/api/hub?path=${encodedUri}`, true);
  }

  getAgent(referalCode): Observable<any> {
    const encodedUri = encodeURI(`${this._relativeUrl}${referalCode}`);
    return this.get(`/api/hub?path=${encodedUri}`, true);
  }

  getCustomer2(customerUserId, customerCode): Observable<any> {
    let encodedUri = encodeURIComponent(`${this._relativeUrl}${customerUserId}&customerCode=${customerCode}`);
    if (customerCode === '') {
      encodedUri = encodeURIComponent(`${this._relativeUrl}${customerUserId}`);
    }
    return this.get(`/api/hub?path=${encodedUri}`, true);
  }

  getCampaignCustomer(customerUserId, campaignCode): Observable<any> {
    let encodedUri = encodeURIComponent(`${this._relativeCampaignUrl}${customerUserId}&campaignCode=${campaignCode}`);
    return this.get(`/api/hub?path=${encodedUri}`, true);
  }

  getToken(): Observable<any> {
    return this.get('/api/hub/token', true);
  }

  getImage(id): Observable<any> {
    let encodedUri = encodeURIComponent(`api/File/GetByFileId?fileId=${id}`);
    return this.get(`/api/hub?path=${encodedUri}&apikey=${this.apikey}`, true);
  }

  getInfo(): Observable<any> {
    return this.getApiKey().pipe(mergeMap(({ data }) => {
      if (!data.Content) {
        window.location.href = '/error404';
        return Observable.of(null);
      }
      this.apikey = data.Content[0].Data.Key;
      const url = this.getKycInfoEndpoint();
      return this.post('/api/hub', {
        apiUrl: url,
        apiKey: this.apikey,
        payload: ""
      }, true);
    }))
  }

  getApiKey(): Observable<any> {
    let url = this._relativeUrlGetApiKey + this.getTenant();
    return this.post('/api/hub', {
      apiUrl: url,
      payload: ""
    }, true)
  }

  getTenant() {
    let url = window.location.href;
    let tenant = url.split('/').length > 4 ? url.split('/')[3] : ''
    return tenant;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/kyc.service.ts